<template lang="pug">
div
  .box-form
    .material-icons.icon-input {{ icon }}
    b-form-group(
      :label-for="inputId"
      :invalid-feedback="invalidFeedback"
    )
      .input-title {{ title }}
      // Text display (read-only)
      div.readonly(
        v-if="readOnly"
        :style="textStyle"
      ) {{ displayValue }}
      
      // Select field
      b-form-select(
        v-else-if="type === 'select'"
        :id="inputId"
        class="input"
        :value="value"
        :options="options"
        :state="state"
        @input="$emit('input', $event)"
        v-bind="$attrs"
      )
      
      // Input field
      b-form-input(
        v-else-if="type === 'input'"
        :id="inputId"
        class="input"
        :value="value"
        :state="state"
        @input="$emit('input', $event)"
        v-bind="$attrs"
      )
      
      // Textarea field
      b-form-textarea(
        v-else-if="type === 'textarea'"
        :id="inputId"
        class="input"
        :value="value"
        :state="state"
        @input="$emit('input', $event)"
        v-bind="$attrs"
      )

      // File field
      b-form-file(
        v-else-if="type === 'file'"
        :id="inputId"
        class="input"
        :value="value"
        :state="state"
        @input="$emit('input', $event)"
        :capture="capture"
        v-bind="$attrs"
      )
      
      // Conditional display (like your example)
      template(v-else-if="type === 'conditional'")
        b-form-select(
          v-if="showInput"
          :id="inputId"
          class="input"
          :value="value"
          :options="options"
          :state="state"
          @input="$emit('input', $event)"
          v-bind="$attrs"
        )
        div.text(
          v-else
          :style="textStyle"
        ) {{ displayValue }}
  
  hr.linea(v-if="showDivider")
</template>

<script>
export default {
  name: 'VFormField',
  inheritAttrs: false,
  props: {
    // Field configuration
    readOnly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'input',
      validator: value => ['input', 'select', 'textarea', 'text', 'conditional', 'file'].includes(value)
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'edit'
    },

    // Input props
    value: {
      type: [String, Number, Boolean, Array, FileList, File],
      default: null
    },
    inputId: {
      type: String,
      default: () => `input-${Math.random().toString(36).substr(2, 9)}`
    },

    capture: {
      type: String,
      default: null
    },
    // Validation
    state: {
      type: Boolean,
      default: null
    },
    invalidFeedback: {
      type: String,
      default: ''
    },

    // Select options
    options: {
      type: Array,
      default: () => []
    },

    // Conditional display
    showInput: {
      type: Boolean,
      default: true
    },
    textStyle: {
      type: [String, Object],
      default: ''
    },

    // Layout
    showDivider: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    displayValue() {
      if (this.type === 'select') {
        const option = this.options.find(option => option.value === this.value)
        return option ? option.text : ''
      }
      return this.value
    }
  },

  emits: ['input']
}
</script>

<style scoped>
.box-form {
  display: flex;
  align-items: flex-start;
}

.material-icons.icon-input {
  color: var(--secondary);
  padding: 0px;
  margin-top: 16px;
  font-size: 30px;
}

.input-title {
  margin-left: 12px;
  color: var(--light-primary);
  font-weight: bold;
  font-size: 13px;
}

.input {
  width: 100%;
}

.readonly {
  min-height: 36px;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
}

.linea {
  background: #C3C3C3;
  margin-top: -16px;
}
</style>